import script from "./PedidosTabla.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidosTabla.vue?vue&type=script&setup=true&lang=js"

import "./PedidosTabla.vue?vue&type=style&index=0&id=df241922&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df241922"]])

export default __exports__